import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
import { BookOpenIcon, HeadphonesIcon } from 'lucide-react';
export function FormatSection() {
  return <div className="bg-dark-900 pb-2 md:pb-8" data-id="element-87">
      <Section data-id="element-88">
        <div className="max-w-2xl mx-auto" data-id="element-89">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center mb-10 md:mb-12" data-id="element-90">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-3" data-id="element-91">
              Lo que vas a obtener con tu compra
            </h2>
            <p className="text-cream-300/70 text-lg" data-id="element-92">
              Acceso inmediato a ambos formatos
            </p>
          </motion.div>

          <div className="space-y-6" data-id="element-93">
            {/* Card 1: El eBook */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.1
          }} className="bg-dark-800 rounded-xl border border-dark-700 p-6 md:p-8" data-id="element-94">
              <div className="w-12 h-12 bg-dark-700 rounded-lg flex items-center justify-center mb-5" data-id="element-95">
                <BookOpenIcon className="w-6 h-6 text-cream-200" data-id="element-96" />
              </div>

              <h3 className="text-xl md:text-2xl font-serif font-bold text-white mb-1" data-id="element-97">
                El eBook
              </h3>
              <p className="text-xs font-sans tracking-[0.2em] text-cream-300/70 uppercase mb-4" data-id="element-98">
                PARA LEER A TU RITMO
              </p>
              <p className="text-cream-200 leading-relaxed" data-id="element-99">
                Ideal si quieres subrayar, tomar notas y volver a capítulos
                clave. Un documento histórico en tus manos.
              </p>
            </motion.div>

            {/* Card 2: El AudioLibro */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="bg-dark-800 rounded-xl border border-dark-700 p-6 md:p-8" data-id="element-100">
              <div className="w-12 h-12 bg-dark-700 rounded-lg flex items-center justify-center mb-5" data-id="element-101">
                <HeadphonesIcon className="w-6 h-6 text-cream-200" data-id="element-102" />
              </div>

              <h3 className="text-xl md:text-2xl font-serif font-bold text-white mb-1" data-id="element-103">
                El AudioLibro
              </h3>
              <p className="text-xs font-sans tracking-[0.2em] text-cream-300/70 uppercase mb-4" data-id="element-104">
                PARA ESCUCHARLO DONDE SEA
              </p>

              <ul className="space-y-3" data-id="element-105">
                <li className="flex items-center gap-3" data-id="element-106">
                  <span className="w-2 h-2 rounded-full bg-gold-500 flex-shrink-0" data-id="element-107" />
                  <span className="text-cream-200" data-id="element-108">
                    Si manejas mucho o viajas
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-109">
                  <span className="w-2 h-2 rounded-full bg-[#1e40af] flex-shrink-0" data-id="element-110" />
                  <span className="text-cream-200" data-id="element-111">
                    Si trabajas y tienes poco tiempo libre
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-112">
                  <span className="w-2 h-2 rounded-full bg-[#dc2626] flex-shrink-0" data-id="element-113" />
                  <span className="text-cream-200" data-id="element-114">
                    Si prefieres la emoción de la voz narrada
                  </span>
                </li>
              </ul>
            </motion.div>
          </div>
        </div>
      </Section>
    </div>;
}